import { RenderPS } from './RenderPS';
import { RenderPD } from './RenderPD';
import { RenderFR } from './RenderFR';
import { RenderOR } from './RenderOR';
import { RenderMLM } from './RenderMLM';
import { RenderMLF } from './RenderMLF';
import { RenderTubetto } from './RenderTubetto';
import { RenderFaston2_8 } from './RenderFaston2_8';
import { RenderFaston6_3 } from './RenderFaston6_3';
import { RenderFaston4_8 } from './RenderFaston4_8';
import { RenderFastonCovered2_8 } from './RenderFastonCovered2_8';
import { RenderFastonCovered4_8 } from './RenderFastonCovered4_8';
import { RenderFastonCovered6_3 } from './RenderFastonCovered6_3';
import { RenderFastonSquadra } from './RenderFastonSquadra';
import { RenderFaston6_3Alt } from './RenderFaston6_3Alt';
import { RenderFastonCovered6_3Alt } from './RenderFastonCovered6_3Alt';

export const TerminalRenderers = {
  PS: RenderPS,
  PD: RenderPD,
  FR: RenderFR,
  MLM: RenderMLM,
  MLF: RenderMLF,
  TR: RenderTubetto,
  FB: RenderFR,
  FY: RenderFR,
  OR: RenderOR,
  OB: RenderOR,
  OY: RenderOR,
  TB: RenderTubetto,
  TY: RenderTubetto,
  FSR2_8: RenderFaston2_8,
  FSR4_8: RenderFaston4_8,
  FSR6_3: RenderFaston6_3, 
  FC2_8: RenderFastonCovered2_8,
  FC4_8: RenderFastonCovered4_8,
  FC6_3: RenderFastonCovered6_3,
  FAS: RenderFastonSquadra,
  FSR6_3_ALT: RenderFaston6_3Alt,
  FC6_3_ALT: RenderFastonCovered6_3Alt
};

export { RenderPS, RenderPD, RenderFR, RenderOR, RenderMLM, RenderMLF, RenderTubetto, RenderFaston2_8, RenderFaston4_8, RenderFaston6_3, RenderFastonCovered2_8, RenderFastonCovered4_8, RenderFastonCovered6_3, RenderFastonSquadra, RenderFaston6_3Alt, RenderFastonCovered6_3Alt };
